import api from "./api";

/**
 * User API Service for admin user management
 * This service handles all API calls related to user management
 * operations available to Developer Master users.
 */
const userAPI = {
  // Admin user management
  getAllAdmins: () => api.get("/users/admins"),
  getAdminById: (id) => api.get(`/users/admins/${id}`),
  createAdmin: (data) => api.post("/users/admins", data),
  updateAdmin: (id, data) => api.put(`/users/admins/${id}`, data),
  deleteAdmin: (id) => api.delete(`/users/admins/${id}`),

  // Admin department assignment
  assignAdminToDepartment: (adminId, departmentId) =>
    api.put(`/users/admins/${adminId}/department`, { departmentId }),
  getAdminsByDepartment: (departmentId) =>
    api.get(`/users/departments/${departmentId}/admins`),

  // User profile management
  getUserProfile: () => api.get("/users/profile"),
  updateUserProfile: (data) => api.put("/users/profile", data),
  deleteUserProfile: () => api.delete("/users/profile"),

  // Get all users
  getAllUsers: () => api.get("/users"),

  // Manager (maintenance superuser) management (developer-master only)
  getAllManagers: () => api.get('/users/managers'),
  getManagerById: (id) => api.get(`/users/managers/${id}`),
  createManager: (data) => api.post('/users/managers', data),
  updateManager: (id, data) => api.put(`/users/managers/${id}`, data),
  deleteManager: (id) => api.delete(`/users/managers/${id}`),
};

export default userAPI;
